module.exports = __webpack_public_path__ + "static/media/thumb.85c7a21e.png";